import { render } from "./ClusterPage.vue?vue&type=template&id=bec6aa0a&scoped=true"
import script from "./ClusterPage.vue?vue&type=script&lang=js"
export * from "./ClusterPage.vue?vue&type=script&lang=js"

import "./ClusterPage.vue?vue&type=style&index=0&id=bec6aa0a&scoped=true&lang=css"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bec6aa0a"]])

export default __exports__